import { Button, Column, Icon, Media, Row, Spacer, Text } from "@bunnix/components";
import Bunnix, { Show, useMemo } from "@bunnix/core";
import { formatRelativeDate } from "../utils/relative-date.mjs";

const { a } = Bunnix;

export default function RegularNewsCard(props = {}) {
  const {
    title, snippet, source, publishedAt, image, url
  } = props.get ? props.get() : props;

  const showImage = useMemo([image],
    (i) => i
  );
  const showSnippet = useMemo([snippet, image], (d, i) =>
    d ? (!i ?? false) : false,
  );

  const RenderImage = () => (
    Show(
      showImage,
      Column(
        { width: "100%", maxHeight: "50%", overflow: "hidden" },
        Media({ content: "cover", src: image })
      )
    )
  )

  const RenderTitle = () => Text(
    {
      fontSize: "x-large", fontAdjust: "large-title", fontWeight: 600,
    }, title
  )

  const RenderSnippet = () => (
    Show(
      showSnippet,
      Text(
        { fontSize: "large", dimmed: true },
        snippet
      )
    )
  )

  const RenderSourceRow = () => (
    Row(
      { alignItems: "end" },
      Text({ fontSize: "large", fontWeight: 600 }, source),
      Spacer(),
      Text({ fontSize: "small", fontWeight: 600, dimmed: true }, formatRelativeDate(publishedAt))
    )
  )

  const RenderBottomRow = () => (
    Row(
      Spacer(),
      Icon({ name: "arrow_up_right" })
    )
  )

  return (
    Column(
      {
        padding: "regular", overflow: "hidden",
        width: "100%", height: "100%",
        fontColor: "primary-on-accent",
        selectable: "none",
      },
      RenderSourceRow(),
      a(
        { href: url, target: "_blank", rel: "noopener noreferrer", fontColor: "primary-on-accent", },
        Column(
          { gap: 24 },
          RenderImage(),
          RenderTitle(),
          RenderSnippet(),
        )
      ),
      Spacer(),
      RenderBottomRow()
    )
  )
}
